export const getters = {
  getSilosShed(state) {
    return state.silosShed;
  },

  getSelectedSilo(state) {
    return state.selectedSilo;
  },

  getNutritionIsLoaded(state) {
    return state.nutritionIsLoaded;
  },

  getNutritionLabel(state) {
    return state.nutritionLabel;
  },

  getNutritionBadgeClass(state) {
    return state.nutritionBadgeClass;
  },

  getNutritionCardClass(state) {
    return state.nutritionCardClass;
  },

  getNutritionIcon(state) {
    return state.nutritionIcon;
  },

  getRationTypes(state) {
    return state.rationTypes;
  },

  getRationTypesAddRation(state) {
    return state.rationTypeAddRation;
  },
  getAlerts(state) {
    return state.alerts.results || [];
  },
  getFeedControls(state) {
    return state.feedControls;
  },

  getDialogState(state) {
    return state.dialogState;
  },

  getDialogLoading(state) {
    return state.dialogLoading;
  },
};
